export const Name = 'add-to-basket';
export const AddToBasketEvent = Name;
export let Method = /*#__PURE__*/function (Method) {
  Method["BUY_FOR_MONEY"] = "BUY_FOR_MONEY";
  Method["BUY_FOR_POINTS"] = "BUY_FOR_POINTS";
  return Method;
}({});
